import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogHeader,
} from "@suraasa/placebo-ui"
import VideoPlayerV2 from "components/VideoPlayerV2"
import { isIOS } from "react-device-detect"

const DEFAULT_LANGUAGE_ID = "default"

type Props = {
  recordingURL: string | null
  onClose: () => void
}

const VideoPlayerDialog = ({ recordingURL, onClose }: Props) => {
  return (
    <Dialog open={Boolean(recordingURL)} onOpenChange={onClose}>
      <DialogContent className="max-w-7xl">
        <DialogHeader></DialogHeader>
        <DialogBody>
          {recordingURL && (
            <VideoPlayerV2
              sources={[
                {
                  language: "English",
                  uuid: DEFAULT_LANGUAGE_ID,
                  url: recordingURL,
                },
              ]}
              defaultLanguageId={DEFAULT_LANGUAGE_ID}
              autoPlay={!isIOS}
            />
          )}
        </DialogBody>
      </DialogContent>
    </Dialog>
  )
}

export default VideoPlayerDialog
